export default __webpack_public_path__ + "static/media/zyjb.888685f0.jpg";